/* global G */
import { curry } from 'lib/util'
import status from 'model/cart/collection/status'

/**
 * Returns a list of translated cart statuses.
 *
 * @param {Gaia.AppModule.Spec} module - app module
 * @param {Gaia.Component.Spec} component - action component
 * @param {Gaia.PlatformEvent|string} eventOrKey
 * @returns {Array} countries
 */
const listCartStatuses = (module, component, eventOrKey) => {
  const key = eventOrKey?.detail?.key || eventOrKey
  const scope = key !== undefined ? status.filter(item => item.key === key) : status

  return scope.map(item => ({
    ...item,
    value: module[G.ADAPTER][G.INTL]._t(
      `status.${item.key}`,
      {
        ns: 'cart',
        _key: `status.${item.key}`,
        defaultValue: item.value,
      },
    ),
  }))
}

export default curry(listCartStatuses)
